import { getTimeDifferenceFromLastLoad, } from "@/utils/vuexTimeUtils";
import {  getFormattedTime } from "@/utils/timeUtils";
import sanitizeHtml from "sanitize-html";

// Speech functions take `t` (a vue-i18n translate function) and `language`
// ('en' | 'cy') so the spoken text matches the language being spoken.

export function destinationForLanguage(service, language) {
  return language === 'cy'
    ? (service.destinationCY || service.destination)
    : (service.destination || service.destinationEN);
}

export function stopNameForLanguage(stop, language) {
  return language === 'cy'
    ? (stop.stopNameCY || stop.stopName)
    : stop.stopName;
}

function serviceParams(service, language) {
  return {
    service: service.service,
    provider: service.providerName,
    destination: destinationForLanguage(service, language),
  };
}

export function stopDescriptionToSpeak(stopDescription) {
  //let stopDescriptionToSpeak = `Stop ${stopDescription.indicator} ${stopDescription.commonName} on ${stopDescription.street}.`;
  
  return splitwordIntoSentencesThenByWordBoundary(stopDescription, 100)
}

export function messagesbyPriorityandDateTime(messages) {
  let output = [...messages].sort((a, b) => {
    return (
      a.priority - b.priority || b.type - a.type || new Date(b.dateTime) - new Date(a.dateTime)
    );
  });
  return output;
}

export function messagesToSpeak(messagesForQR, latestMessageOnly, t) {
  let arrayOfMessages = [];
  let orderedMessages = messagesbyPriorityandDateTime(messagesForQR);
  
  let myMessages = latestMessageOnly
  ? orderedMessages.slice(0, 1)
  : orderedMessages;
  
  let messageTexts = myMessages.map((m) => m.text);
  
  if (messageTexts.length <= 0) return [];
  
  for (let [i, message] of messageTexts.entries()) {
    message = removeAnchorTags(message);
    
    let arrayOfTexts = [];
    if (messageTexts.length > 1) {
      arrayOfTexts.push(
        t("speech.messageNofM", { n: i + 1, total: messageTexts.length })
      );
    } else {
      arrayOfTexts.push(t("speech.message"))
    }
    let texts = splitwordIntoSentencesThenByWordBoundary(message, 100);
    texts.forEach((text) => {
      arrayOfTexts.push(text);
    });
    if (arrayOfTexts.length > 0) {
      arrayOfMessages.push(arrayOfTexts);
    }
  }
  
  return arrayOfMessages;
}

export function formattedTextHeader(service, t, language) {
  return service.monitored ? formattedmonitoredTextHeader(service, t, language) : formattedUnmonitoredTextHeader(service, t, language)
}

export function formattedUnmonitoredTextVias(via, t, language) {
  return t("speech.stopAtTime", {
    stop: stopNameForLanguage(via, language),
    time: getFormattedTime(via.stopDue, "HH:mm"),
  }) + " ";
}

export function departuresToSpeak(services, t, language) {
  const arrayOfSpeeches = [];

  if (services == null || services.length <= 0) return [];

  for (const service of services) {
    let arrayOfStrings = [];
    arrayOfStrings = departureToSpeak(service, t, language)
    arrayOfSpeeches.push(arrayOfStrings);
  }
  return arrayOfSpeeches;
}



function getFormatedMonitorDepartureText(service, t, language) {
  const params = serviceParams(service, language);
  const timedifference = getTimeDifferenceFromLastLoad(service.due);

  if (timedifference <= 0) {
    return t("speech.serviceDueNow", params);
  }
  return t("speech.serviceDueInMinutes", { ...params, n: timedifference }, timedifference);
}

function getEstimatedStopTime(service, t, language) {

  if (service.via.length <= 0) return "";
  if (service.serviceMessage && service.serviceMessage.toUpperCase() == "CANCELLED") return "";

  let stringArray = [t("speech.stoppingAt") + " "];

  service.via.forEach((stop) => {
    stringArray.push(
      t(
        "speech.stopAfterMinutes",
        { stop: stopNameForLanguage(stop, language), n: stop.estimatedMinutesToStop },
        stop.estimatedMinutesToStop
      )
    );
  });

  return stringArray;
}

function extractTextFromHtmlString(htmlString) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");
  return doc.body.textContent || "";
}

function splitTextIntoArrayOfSentenses(message) {
  let elementArray = message
    .toString()
    .replace(/([.?!])\s*(?=[A-Z])/g, "$1|")
    .replace(/([,])\s*/g, "$1|")
    .split("|");
  return elementArray;
}

function removeAnchorTags(text) {
  let sanitizedMessage = sanitizedText(text);
  if (sanitizedMessage.includes("<a") && sanitizedMessage.includes("</a>")) {
    return extractTextFromHtmlString(sanitizedMessage);
  }
  return sanitizedMessage;
}

function splitTextByWordBoundary(sentence, maxLength) {
  const regex = new RegExp(`.{1,${maxLength}}(\\s|$)|\\S+?(\\s|$)`, "g");
  let chunks = sentence.match(regex) || [];

  chunks = chunks
    .map((chunk) => chunk.trim())
    .filter((chunk) => chunk.length > 0);

  return chunks;
}

function splitwordIntoSentencesThenByWordBoundary(message, maxLength) {
  let textArray = [];
  let sentences = splitTextIntoArrayOfSentenses(message);

  for (let sentence of sentences) {
    let texts = splitTextByWordBoundary(sentence, maxLength);
    texts.forEach((text) => {
      textArray.push(text);
    });
  }
  return textArray;
}

function sanitizedText(text) {
  return sanitizeHtml(text, {
    allowedTags: ["a"],
    allowedAttributes: {
      a: ["href", "target"],
    },
  });
}

function serviceMessage(service, t, language)
{
  let firstLine = ''
  if (service.serviceMessage && service.serviceMessage.toUpperCase() == "CANCELLED") {
    firstLine = t("speech.serviceCancelled", {
      ...serviceParams(service, language),
      time: getFormattedTime(service.due),
    });
    }
    return firstLine;
}

function formattedUnmonitoredTextHeader(service, t, language) {
  let firstLine = "";

  if (service.serviceMessage == null
        || service.serviceMessage == 'noReport') {
      firstLine = t("speech.serviceDueAt", {
        ...serviceParams(service, language),
        time: getFormattedTime(service.aimedDepartureTime),
      });

  } else {
    firstLine = serviceMessage(service, t, language);
  }
  return splitwordIntoSentencesThenByWordBoundary(firstLine, 100)
}

function formattedUnmonitoredTextAllVias(service, t, language) {
  let arrayOfStrings = [];
  if (service.serviceMessage && service.serviceMessage.toUpperCase() == "CANCELLED") return arrayOfStrings;
  for (let [ i, via ] of service.via.entries()) {
    let addtionalLine = "";
    //first additional line if multiple stops
    if (i === 0 && service.via.length > 1) {
      addtionalLine += t("speech.thisBusWillStopAt") + " ";
    }
    //last line
    if (i === service.via.length - 1) {
      addtionalLine += t("speech.andTerminatesAt") + " ";
    }

    addtionalLine += formattedUnmonitoredTextVias(via, t, language)
    arrayOfStrings.push(addtionalLine);
  }
  return arrayOfStrings;
}

function formattedUnmonitoredText(service, t, language) {
  let arrayOfStrings = [];
  let firstline = formattedUnmonitoredTextHeader(service, t, language);
  arrayOfStrings.push(...firstline)

  if (service.via && service.via.length >= 1) {
    arrayOfStrings.push(...formattedUnmonitoredTextAllVias(service, t, language))
  }
  return arrayOfStrings;
}

function formattedmonitoredTextHeader(service, t, language)
{
  let firstLine = '';
  if (service.serviceMessage != null && service.serviceMessage.toUpperCase() == "CANCELLED") {
    firstLine = serviceMessage(service, t, language);
    return splitwordIntoSentencesThenByWordBoundary(firstLine, 100)
  }

  firstLine = getFormatedMonitorDepartureText(service, t, language)

    return splitwordIntoSentencesThenByWordBoundary(firstLine, 100)

}

function formattedMonitoredText(service, t, language) {
  let arrayOfStrings = [];

  //check to see if service message
  arrayOfStrings.push(...formattedmonitoredTextHeader(service, t, language));
  let estimatedStopTime = getEstimatedStopTime(service, t, language);
  arrayOfStrings.push(...estimatedStopTime);
  return arrayOfStrings;
}

function departureToSpeak(service, t, language)
{
  let arrayOfStrings = ''
  if (!service.monitored) {
    arrayOfStrings = formattedUnmonitoredText(service, t, language);
  } else {
    arrayOfStrings = formattedMonitoredText(service, t, language);
  }
  return arrayOfStrings;
}

